"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Ws = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 2880 1440", ...props },
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { id: "ws_svg__a", d: "m0 0 .309.951L-.5.363h1l-.809.588z" })),
    react_1.default.createElement("path", { fill: "#ce1126", d: "M0 0h2880v1440H0z" }),
    react_1.default.createElement("path", { fill: "#002b7f", d: "M0 0h1440v720H0z" }),
    react_1.default.createElement("g", { fill: "#fff" },
        react_1.default.createElement("use", { xlinkHref: "#ws_svg__a", transform: "matrix(160 0 0 160 720 30)" }),
        react_1.default.createElement("use", { xlinkHref: "#ws_svg__a", transform: "matrix(160 0 0 160 500 210)" }),
        react_1.default.createElement("use", { xlinkHref: "#ws_svg__a", transform: "matrix(150 0 0 150 945 180)" }),
        react_1.default.createElement("use", { xlinkHref: "#ws_svg__a", transform: "matrix(100 0 0 100 830 364.894)" }),
        react_1.default.createElement("use", { xlinkHref: "#ws_svg__a", transform: "matrix(200 0 0 200 720 499.789)" }))));
exports.default = Ws;
//# sourceMappingURL=Ws.js.map